export const MAIN_BRANCH = 'main';

export const LeftNavItemCategoryOptions = {
  Admin: 'admin',
  Advanced: 'advanced',
  Apps: 'apps',
  Controls: 'controls',
  Performance: 'performance',
  Tools: 'tools',
  Support: 'support',
} as const;

export const AtlasRouteIds = {
  Alarms: 'alarms',
  AtlasLearning: 'atlas-learning',
  Blast: 'blast',
  CoincidentPeaks: 'coincident-peaks',
  CompressorSequencer: 'compressor-sequencer',
  CondenserSequencer: 'condenser-sequencer',
  DemandEvents: 'demand-events',
  DemandResponseAdmin: 'demand-response-admin',
  DemandResponseEvents: 'demand-response-events',
  EnergyAI: 'energy-ai',
  Equipment: 'equipment',
  FacilityConfig: 'facility-config',
  FacilityPerformance: 'facility-performance',
  HelpCenter: 'help-center',
  IOStatus: 'io-status',
  Map: 'map',
  Netkit: 'netkit',
  OfflineEscapeHatch: 'offline-escape-hatch',
  OfflineFaq: 'offline-faq',
  PredictiveDryingControl: 'predictive-drying-control',
  ProcessView: 'process-view',
  Reports: 'reports',
  Trends: 'trends',
  SensorCalibration: 'sensor-calibration',
  Shutdown: 'shutdown',
  SiteNavigation: 'site-navigation',
  Support: 'support',
  System: 'system',
  UserManagement: 'user-management',
} as const;

// Atlas "routes" that are not navigable by a link
export const ATLAS_NO_LINK_ROUTES = [
  AtlasRouteIds.AtlasLearning,
  AtlasRouteIds.HelpCenter,
  AtlasRouteIds.SiteNavigation,
  AtlasRouteIds.Support,
];

// Atlas routes that are panels in Darkwing and require deep linking
export const ATLAS_PANEL_ROUTE_IDS = [
  AtlasRouteIds.Shutdown,
  AtlasRouteIds.SensorCalibration,
  AtlasRouteIds.CompressorSequencer,
  AtlasRouteIds.CondenserSequencer,
] as const;

/**
 * Routes pending migration from Darkwing to Gaia.
 * These routes have no Gaia implementation yet and must redirect to Darkwing.
 *
 * REMOVAL: As features are implemented in Gaia, remove them from this set.
 * When this set is empty, delete it and the check in route-resolution.ts.
 *
 * @deprecated This constant will be removed when migration is complete.
 */
export const PENDING_MIGRATION_FROM_DARKWING_ROUTES: Set<string> = new Set([
  AtlasRouteIds.IOStatus,
  AtlasRouteIds.Blast,
  AtlasRouteIds.EnergyAI,
  AtlasRouteIds.FacilityConfig,
  AtlasRouteIds.UserManagement,
  AtlasRouteIds.OfflineEscapeHatch,
  AtlasRouteIds.Shutdown,
]);

export const NavOptions = {
  Main: 'main',
  Facility: 'facility',
  Configuration: 'configuration',
} as const;
